<template>
  <div class="min-h-screen flex items-center justify-center">
    <div class="text-center space-y-4 px-2">
      <div class="flex justify-center gap-3">
        <img src="/images/logo.webp" alt="Links Digest" class1="h-10 w-10" />
      </div>

      <h1 class="text-xl font-semibold">
        Redirecting...
      </h1>

      <p class="text-white-600">
        You're about to visit an external website. 
      </p>
      <p class="text-white-600">
        Please note that we don't manage or control its content or privacy practices.
      </p>
      <p class="text-gray-600">
        You will be redirected in
        <span class="font-bold">{{ counter }}</span>
        seconds
      </p>
      <div class="mt-3">
        <div class="three-body">
        <div class="three-body__dot"></div>
        <div class="three-body__dot"></div>
        <div class="three-body__dot"></div>
        </div>
      </div>


      <a :href="addUTMParams(target)" class="text-sm text-gray-500 break-all" rel="ugc nofollow">
        {{ target }}
      </a>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { addUTMParams } from "@/utils/url.utils";


const route = useRoute()
const router = useRouter()

const numberSeconds  = 5;
const counter = ref(numberSeconds)
const target = route.params.url || '/'

let interval

onMounted(() => {
  
  interval = setInterval(() => {
    counter.value--

    if (counter.value === 0) {
      clearInterval(interval)

      // URL externa ou interna
      if (target.startsWith('http')) {
        window.location.href = addUTMParams(target)
      } else {
        router.push(target)
      }
    }
  }, 1000)
  
})

onUnmounted(() => {
  clearInterval(interval)
})
</script>
<style scoped>
/* From Uiverse.io by dovatgabriel */ 
.three-body {
 --uib-size: 35px;
 --uib-speed: 0.8s;
 --uib-color: #5D3FD3;
 position: relative;
 display: inline-block;
 height: var(--uib-size);
 width: var(--uib-size);
 animation: spin78236 calc(var(--uib-speed) * 2.5) infinite linear;
}

.three-body__dot {
 position: absolute;
 height: 100%;
 width: 30%;
}

.three-body__dot:after {
 content: '';
 position: absolute;
 height: 0%;
 width: 100%;
 padding-bottom: 100%;
 background-color: var(--uib-color);
 border-radius: 50%;
}

.three-body__dot:nth-child(1) {
 bottom: 5%;
 left: 0;
 transform: rotate(60deg);
 transform-origin: 50% 85%;
}

.three-body__dot:nth-child(1)::after {
 bottom: 0;
 left: 0;
 animation: wobble1 var(--uib-speed) infinite ease-in-out;
 animation-delay: calc(var(--uib-speed) * -0.3);
}

.three-body__dot:nth-child(2) {
 bottom: 5%;
 right: 0;
 transform: rotate(-60deg);
 transform-origin: 50% 85%;
}

.three-body__dot:nth-child(2)::after {
 bottom: 0;
 left: 0;
 animation: wobble1 var(--uib-speed) infinite
    calc(var(--uib-speed) * -0.15) ease-in-out;
}

.three-body__dot:nth-child(3) {
 bottom: -5%;
 left: 0;
 transform: translateX(116.666%);
}

.three-body__dot:nth-child(3)::after {
 top: 0;
 left: 0;
 animation: wobble2 var(--uib-speed) infinite ease-in-out;
}

@keyframes spin78236 {
 0% {
  transform: rotate(0deg);
 }

 100% {
  transform: rotate(360deg);
 }
}

@keyframes wobble1 {
 0%,
  100% {
  transform: translateY(0%) scale(1);
  opacity: 1;
 }

 50% {
  transform: translateY(-66%) scale(0.65);
  opacity: 0.8;
 }
}

@keyframes wobble2 {
 0%,
  100% {
  transform: translateY(0%) scale(1);
  opacity: 1;
 }

 50% {
  transform: translateY(66%) scale(0.65);
  opacity: 0.8;
 }
}

</style>